import { useEffect, useState } from "react";
import { AutoInvestmentService } from "../../../services/autoInvestmentService";
import SectionWithHeading from "../../../shared/components/common/sectionWithHeading";
import { FormikProvider, useFormik } from "formik";
import { FormHelper } from "../../../helpers/formHelper";
import { Box, Checkbox, FormControlLabel } from "@mui/material";
import InputWrapper from "../../../shared/formUtilities/useInput";
import { AutoInvestmentSchema } from "../../../shared/validations/schema";

export const AutoInvestmentCreate = () => {
  const service = new AutoInvestmentService();
  const [loading, setLoading] = useState(false);
  const [isEditInfo, setIsEditInfo] = useState(false);

  const form = useFormik({
    initialValues: {
      isAutoDistributeEnabled: false,
      preFillCampaignPercent: "",
      expirationPeriod: "",
      autoInvestmentConfigurationTypes: [{
        type: 1,
        maxExposure: "",
      }, {
        type: 2,
        maxExposure: "",
      }]
    },
    validationSchema: AutoInvestmentSchema,
    onSubmit: () => {
      onUpdate();
    },
    ...FormHelper.formikProps()
  });

  useEffect(() => {
    getAutoInvestment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAutoInvestment = () => {
    setLoading(true);
    service.getAutoInvestment().then(resp => {
      form.setValues(resp.data);
      setLoading(false);
    }).catch(err => setLoading(false));
  };
  const onUpdate = () => {
    setLoading(true);
    service.updateAutoInvestment(form.values).then(resp => {
      setLoading(false);
      setIsEditInfo(!isEditInfo);
    }).catch(err => setLoading(false));
  };

  const onEditInfo = (e) => {
    e.preventDefault();
    if (isEditInfo) {
      FormHelper.validateForm(form);
    } else {
      setIsEditInfo(!isEditInfo);
    }
  };

  return <Box>
    <FormikProvider value={form}>
      <SectionWithHeading
        isEditButton={true}
        onEditInfo={(e) => {
          onEditInfo(e);
        }}
        isEditToggle={isEditInfo}
        loading={loading} heading={'Update Auto Investment'}
      >
        <fieldset disabled={!isEditInfo}>
          <Box className="flex flex-col space-y-2">
            <Box className="flex items-center justify-between">
              <Box className="grid grid-cols-2 gap-2 w-[60%]">
                <InputWrapper
                  type="number"
                  name='preFillCampaignPercent'
                  key={'preFillCampaignPercent'}
                  label={'Pre Fill Campaign Percentage'} />
                <InputWrapper
                  type="text"
                  name='expirationPeriod'
                  key={'expirationPeriod'}
                  label={'Expiration Period'} />
              </Box>
              <Box>
                <FormControlLabel
                  label={'Auto Distribute'}
                  control={
                    <Checkbox
                      onChange={(e) => {
                        form.setFieldValue('isAutoDistributeEnabled', e.target.checked);
                      }}
                      name={'isAutoDistributeEnabled'}
                      checked={!!form.values.isAutoDistributeEnabled}
                      value={!!form.values.isAutoDistributeEnabled}
                    />
                  }
                />
              </Box>
            </Box>
            <Box className="grid grid-cols-2 gap-2">
              {form.values.autoInvestmentConfigurationTypes.map((resp, index) => {
                return <SectionWithHeading key={index} heading={resp?.type === 1 ? 'Balanced' : 'Conservative'}>
                  <InputWrapper
                    type="number"
                    name={`autoInvestmentConfigurationTypes[${index}].maxExposure`}
                    key={`autoInvestmentConfigurationTypes[${index}].maxExposure`}
                    label={'Maximum Exposure (%)'}
                  />
                </SectionWithHeading>;
              })}
            </Box>
          </Box>
        </fieldset>
      </SectionWithHeading>
    </FormikProvider>
  </Box>;
};